import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import { Grid } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { CAREPLAN_COMPONENT } from '../../shared/Strings';
import { DEFAULT_NULL_REPLACEMENT } from '../../shared/constants';

const boxStyle = {
  padding: '16px',
  background: '#FFFFFF',
  border: '1px solid #E4E4E4',
  boxSizing: 'border-box',
  borderRadius: ' 8px',
  display: 'flex',
  alignItems: 'center',
  marginTop: 2,
};
const heading = {
  fontWeight: 600,
  marginTop: 3,
  fontSize: '16px',
  lineHeight: '19px',
};
function CarePlanComponent(props) {
  let navigate = useNavigate();

  let problemArray = props.carePlanflyoutData?.problems.map(item => JSON.parse(item));

  return (
    <div>
      <Box sx={{ mt: 5 }}>
        <Typography sx={heading}>
          {CAREPLAN_COMPONENT.LABEL_TEXT.PROBLEMS}
        </Typography>
        <Box sx={boxStyle}>
          <Typography sx={{ fontWeight: 500, marginLeft: 2 }}>
            {problemArray.map((val, index) => (
              <li key={index}>{val.code}</li>
            ))}
          </Typography>
        </Box>
        <Typography sx={heading}>
          {CAREPLAN_COMPONENT.LABEL_TEXT.GOALS}
        </Typography>
        <Box sx={boxStyle}>
          <Typography sx={{ fontWeight: 500, marginLeft: 2 }}>
            {props.carePlanflyoutData?.goals.map((val, index) => (
              <li key={index}>{val}</li>
            ))}
          </Typography>
        </Box>
        <Typography sx={heading}>
          {CAREPLAN_COMPONENT.LABEL_TEXT.ACTIVITIES}
        </Typography>
        <Box sx={boxStyle}>
          <Typography sx={{ fontWeight: 500, marginLeft: 2 }}>
            {props.carePlanflyoutData?.activitics.map((val, index) => (
              <li key={index}>{val}</li>
            ))}
          </Typography>
        </Box>
      </Box>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '19px',
          mt: 4,
        }}>
        {CAREPLAN_COMPONENT.LABEL_TEXT.CARE_TEAM}
      </Typography>
      <Grid container spacing={2}>
        {props?.careTeamData?.data.map((data, index) => {
          const refId = data?.reference?.split('/')[1];
          return (
            <Grid key={index} item xs={12} md={6}>
              <Box
                onClick={() => {
                  navigate(`/care/careTeam?refId=${refId}`);
                }}
                sx={{
                  mt: 2,
                  border: ' 1px solid #E4E4E4',
                  borderRadius: ' 8px',
                  padding: '12px',
                  paddingRight: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  cursor: 'pointer',
                }}>
                <Box
                  sx={{
                    ml: 1,
                  }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      color: '#1F1F1F',
                    }}>
                    {JSON.parse(data?.display)?.name ||
                      DEFAULT_NULL_REPLACEMENT}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: '14px',
                      color: '#828282',
                      textAlign: 'left',
                    }}>
                    {JSON.parse(data?.display)?.category ||
                      DEFAULT_NULL_REPLACEMENT}
                  </Typography>
                </Box>
                <ChevronRightIcon></ChevronRightIcon>
              </Box>
            </Grid>
          );
        })}
      </Grid>

      {/*<Typography
        sx={{
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '19px',
          mt: 4,
        }}> 
      {CAREPLAN_COMPONENT.LABEL_TEXT.OPTIONS} 
      </Typography>*/}
      {/*<Grid container spacing={2}>
        <Grid item xs={6}>
          <Box
            sx={{
              mt: 2,
              border: ' 1px solid #E4E4E4',
              borderRadius: ' 8px',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '16px',
                color: '#1F1F1F',
              }}>
              {CAREPLAN_COMPONENT.LABEL_TEXT.HISTORICAL_RECORD}
            </Typography>

            <ChevronRightIcon
              sx={{
                paddingLeft: '3px',
              }}></ChevronRightIcon>
          </Box>
            </Grid> 
        <Grid item xs={6}>
          <Box
            sx={{
              mt: 2,
              border: ' 1px solid #E4E4E4',
              borderRadius: ' 8px',
              padding: '12px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '16px',
                color: '#1F1F1F',
              }}>
              {CAREPLAN_COMPONENT.LABEL_TEXT.HISTORICAL_RECORD}
            </Typography>

            <ChevronRightIcon
              sx={{
                paddingLeft: '3px',
              }}></ChevronRightIcon>
          </Box>
        </Grid>
            </Grid> */}
    </div>
  );
}

export default CarePlanComponent;
